import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalHttpClient } from '../global.http.client';
import { IPage } from '../models/common/paging';
import { BaseService } from './base.service';
import { ISearchService } from './search.service';
import { Configuration } from '../configuration';
import { ContractAwardSearchModel, ContractAwardSummaryDto } from '../models/contract.awards/contract.award.models';
import { SearchBookmarkedContractAwardsDto } from '../models/contract.awards/contract.award.models';
import { TenderTabCountDto } from '../models/tenders/tender.tab.count.model';
import { TenderTabInformationDto } from '../models/tenders/tender.tab.information.model';
import { Helpers } from '../helpers';

@Injectable()
export class ContractAwardService extends BaseService implements ISearchService<ContractAwardSearchModel,
ContractAwardSummaryDto> {

    constructor(private readonly helpers: Helpers, http: GlobalHttpClient, private readonly configuration: Configuration) {
        super(http);
    }

    search(request: ContractAwardSearchModel): Observable<IPage<ContractAwardSummaryDto>> {
        return this.http.post<IPage<ContractAwardSummaryDto>>('contractAwards/search', request);
    }

    downloadCsv(request: ContractAwardSearchModel) {
        var url = `${this.configuration.routing.api.baseUrl}/contractAwards/getSearchCsv?${this.helpers.uriEncode(request)}`;
        window.location.href = url;
    }

    getDetails(noticeId: number) {
        return this.http.get(`contractAwards/getDetails/${noticeId}`);
    }

    getHvtSection(noticeId: number, sectionNumber: number) {
        return this.http.get(`notices/hvtSection/${noticeId}/${sectionNumber}`);
    }

    getSchema8Section(noticeId: number, sectionNumber: number) {
        return this.http.get(`notices/schema8Section/${noticeId}/${sectionNumber}`);
    }

    addNote(noticeId: number, content: string) {
        return this.http.post('noticeActions/addNote', { noticeId: noticeId, content: content });
    }

    getForPrint(noticeId: number) {
        return this.http.get(`notices/getForPrint/${noticeId}`);
    }

    bookmark(noticeId: number) {
        return this.http.get(`noticeActions/bookmark/${noticeId}`);
    }

    getBookmarked(request: SearchBookmarkedContractAwardsDto) {
        return this.http.getWithParams('contractAwards/getBookmarked', request);
    }

    getSharedBookmarked(request: SearchBookmarkedContractAwardsDto) {
        return this.http.getWithParams('contractAwards/getSharedBookmarked', request);
    }

    getBookmarks(request: SearchBookmarkedContractAwardsDto) {
        return this.http.getWithParams('contractAwards/getBookmarks', request);
    }

    removeBookmark(bookmarkId: number) {
        return this.http.delete(`noticeActions/bookmark/${bookmarkId}`);
    }

    getAwardDetails(noticeId: number) {
        return this.http.get(`contractAwards/awardDetails/${noticeId}`);
    }

    getTabCount(contractInfo: TenderTabInformationDto): Observable<TenderTabCountDto> {
        return this.http.post<TenderTabCountDto>('contractAwards/getTabCount', contractInfo);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/contract.award.service.ts